const ShoppingCards = () => {
  return (
    <section>
      
    </section>
  );
};

export default ShoppingCards;
